import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import HomeFeedUICard from '../../components/HomeFeedUICard';
import { getTargetURL } from '../../utils/home/factories';
import { getHomeMapCards, getHomeMapSelectedRestaurantId } from '../../selectors/homeMapSelectors';
import { PRELOAD_LIMIT } from '../../utils/home/constants';
import { isInView } from './utils';

import styles from './styles.scss';

class HomeMapCards extends Component {
  selectedCardElement = null;

  componentDidUpdate(prevProps) {
    if (this.props.selectedRestaurantId !== prevProps.selectedRestaurantId) {
      this.onRestaurantChanged();
    }
  }

  onRestaurantChanged = () => {
    const { isScrolling, scrollIntoView, scrollingDirection } = this.props;
    const el = this.selectedCardElement;

    if (el && !isScrolling && !isInView(el)) {
      scrollIntoView(el, {
        behavior: 'smooth',
        block: scrollingDirection === 'horizontal' ? 'start' : 'center',
        inline: scrollingDirection === 'horizontal' ? 'start' : 'nearest',
      });
    }
  };

  render() {
    const { cards, selectedRestaurantId } = this.props;

    if (cards.length === 0) {
      return null;
    }

    return (
      <ul className={styles.outer}>
        {cards.map((card, cardIndex) => {
          const url = getTargetURL(card.target);
          const restaurantId = card.target.restaurant.id;
          const isHighlighted = restaurantId === selectedRestaurantId;
          const cardSpacerClass = classnames('home-map__card-spacer', styles.cardSpacer);
          const cardWrapperClass = classnames(styles.cardWrapper, {
            [styles.isHighlighted]: isHighlighted,
          });

          return (
            <li
              key={restaurantId}
              className={cardSpacerClass}
              data-restaurant-id={restaurantId}
              ref={(el) => {
                if (el && isHighlighted) {
                  this.selectedCardElement = el;
                }
              }}
            >
              <div className={cardWrapperClass}>
                <HomeFeedUICard {...card} url={url} preLoad={cardIndex < PRELOAD_LIMIT} />
              </div>
            </li>
          );
        })}
      </ul>
    );
  }
}

HomeMapCards.propTypes = {
  cards: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  isScrolling: PropTypes.bool.isRequired,
  scrollingDirection: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  scrollIntoView: PropTypes.func.isRequired,
  selectedRestaurantId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  cards: getHomeMapCards(state),
  selectedRestaurantId: getHomeMapSelectedRestaurantId(state),
});

export default connect(mapStateToProps)(HomeMapCards);
